import {
  useMutation,
  UseMutationOptions,
  DefaultError
} from '@tanstack/react-query';

import {
  postResend,
  PostResendPayload,
  PostResendQuery,
  PostResendResponse
} from '~/lib/services/api/user';

function useResend () {
  const mutationFn: PostResendQuery = async (newData) => {
    const response = await postResend(newData);
    return response.data;
  };

  const options: UseMutationOptions<
    PostResendResponse,
    DefaultError,
    PostResendPayload,
    unknown
  > = {
    mutationFn
  };

  return useMutation(options);
}

export default useResend;
